// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2ZJYw","upload":"Small_upload__269px","imageWrap":"Small_imageWrap__3LB2z","removeBtn":"Small_removeBtn__LhHzu"};